// extracted by mini-css-extract-plugin
module.exports = {"root":"SliderTimeMarkerStyles__root verse-time-marker font-size--extra-small font-style--button-1","nub":"SliderTimeMarkerStyles__nub","mouseOver":"SliderTimeMarkerStyles__mouseOver","heightDefinition":"SliderTimeMarkerStyles__heightDefinition","widthDefinition":"SliderTimeMarkerStyles__widthDefinition"};
    if(module.hot) {
      // 1790535735275
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  